module.exports = __webpack_public_path__ + "static/media/wizualizacja-78.90bc3c16.png";